module.exports = __webpack_public_path__ + "img/Logo_Print-01.161120f2.png";